import { render, staticRenderFns } from "./PoliticalContributionForm.vue?vue&type=template&id=00b19c5a&scoped=true"
import script from "./PoliticalContributionForm.vue?vue&type=script&lang=js"
export * from "./PoliticalContributionForm.vue?vue&type=script&lang=js"
import style0 from "./PoliticalContributionForm.vue?vue&type=style&index=0&id=00b19c5a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b19c5a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build_997aa59e/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00b19c5a')) {
      api.createRecord('00b19c5a', component.options)
    } else {
      api.reload('00b19c5a', component.options)
    }
    module.hot.accept("./PoliticalContributionForm.vue?vue&type=template&id=00b19c5a&scoped=true", function () {
      api.rerender('00b19c5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/compliance/AttestationManager/Forms/PoliticalContributionForm.vue"
export default component.exports